import Dropdown from './_Dropdown';
import type { ComparisonProduct } from './types';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  selectedSkus: Array<string | ''>;
  selectableProducts: Array<ComparisonProduct>;
  updateSelectedProducts: (sku: string, index: number) => void;
  asContentRow?: boolean;
  className?: string;
}

const DropdownWrapper = ({
  asContentRow,
  selectedSkus,
  selectableProducts,
  updateSelectedProducts,
}: Props) => {
  return (
    <div
      className={classNames(
        'grid bg-white px-1 sm:px-6 pt-4 gap-1 sm:gap-6 pb-2 w-full z-50 sticky top-[calc(var(--navTop)_+_var(--sticky-nav-height))]',
        asContentRow ? 'grid-cols-2 md:hidden' : 'grid-cols-2 md:grid-cols-4',
      )}
    >
      <div className="hidden md:block" />
      {selectedSkus.map((sku, i) => {
        return (
          <div className="flex flex-col text-center h-full" key={i}>
            <Dropdown
              sku={sku}
              products={selectableProducts}
              updateSelectedProducts={updateSelectedProducts}
              index={i}
              className="block"
            />
          </div>
        );
      })}
    </div>
  );
};

export default DropdownWrapper;
